var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.15,
    height: 44.204,
    viewBox: "0 0 47.15 44.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M38.507,32.357H8.646V30.786A.786.786,0,0,0,7.3,30.23L.232,37.3a.785.785,0,0,0,0,1.111L7.3,45.486a.785.785,0,0,0,1.341-.556V43.359H38.507a2.36,2.36,0,0,1,2.358,2.357V55.932a2.36,2.36,0,0,1-2.358,2.358H34.578V48.271a.785.785,0,0,0-.786-.786H.787A.785.785,0,0,0,0,48.271V73.417a.785.785,0,0,0,.786.786H33.792a.785.785,0,0,0,.786-.786V63h3.929a8.654,8.654,0,0,0,8.644-8.644V41A8.654,8.654,0,0,0,38.507,32.357ZM1.573,67.916H33.006v1.572H1.573Zm0-5.43a4.721,4.721,0,0,1,3.859,3.858H1.573Zm31.433-3.214V60.9a6.292,6.292,0,0,0-5.447,5.446H7.02A6.293,6.293,0,0,0,1.573,60.9V54.5A6.292,6.292,0,0,0,7.02,49.056H27.561A6.292,6.292,0,0,0,33.007,54.5v4.77Zm0,3.214v3.858H29.148A4.722,4.722,0,0,1,33.006,62.487Zm0-9.572a4.721,4.721,0,0,1-3.859-3.859h3.859ZM5.432,49.056a4.722,4.722,0,0,1-3.859,3.859V49.056ZM1.573,72.631V71.06H33.006v1.572ZM45.58,54.361a7.08,7.08,0,0,1-7.073,7.073H34.578V59.862h3.929a3.934,3.934,0,0,0,3.929-3.929V45.717a3.934,3.934,0,0,0-3.929-3.929H7.86a.785.785,0,0,0-.786.786v.46L1.9,37.858l5.175-5.175v.46a.785.785,0,0,0,.786.786H38.507A7.08,7.08,0,0,1,45.58,41Zm0,0",
    transform: "translate(-0.001 -30)",
    fill: "#1d2547"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M125.5,256a5.5,5.5,0,1,0,5.5,5.5A5.508,5.508,0,0,0,125.5,256Zm0,9.43a3.929,3.929,0,1,1,3.929-3.929A3.934,3.934,0,0,1,125.5,265.434Zm0,0",
    transform: "translate(-108.216 -233.804)",
    fill: "#1d2547"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M264,304h1.572v1.572H264Zm0,0",
    transform: "translate(-238.071 -277.089)",
    fill: "#1d2547"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M72,304h1.572v1.572H72Zm0,0",
    transform: "translate(-64.931 -277.089)",
    fill: "#1d2547"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M88,56h7.073v1.572H88Zm0,0",
    transform: "translate(-79.359 -50.503)",
    fill: "#1d2547"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M176,56h1.572v1.572H176Zm0,0",
    transform: "translate(-158.715 -50.503)",
    fill: "#1d2547"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M208,56h1.572v1.572H208Zm0,0",
    transform: "translate(-187.572 -50.503)",
    fill: "#1d2547"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M240,56h1.572v1.572H240Zm0,0",
    transform: "translate(-216.429 -50.503)",
    fill: "#1d2547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices3);
export default __webpack_public_path__ + "static/media/services3.bb5e11018ca74bdb10a902ca1c4ef509.svg";
export { ForwardRef as ReactComponent };